module.exports = __webpack_public_path__ + "img/fre_logo.57440ec5.svg";